module.exports = __webpack_public_path__ + "img/pump-20.3f6ea007.svg";